// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-form .el-form-item[data-v-de088252] {\n  margin-bottom: 30px;\n}\n[data-v-de088252] .el-dialog__body {\n  padding-top: 0px;\n}\n", ""]);
// Exports
module.exports = exports;
